import invert from 'lodash/invert';

export default {
  SUPER_USER: 'superUser',
  POWER_USER: 'powerUser',
  USER: 'user',
};

export const userRolesDictionary: Record<string, string> = {
  user: 'User',
  powerUser: 'Power User',
  superUser: 'Super User',
};

export const userRolesLabelToNameDictionary = invert(userRolesDictionary);


